import { useParams, useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import ApiService from '../../services/api-service';
import cookieStorage from '../../services/cookie-storage';
import { getUserId } from '../../constants/function';
import { v4 as uuidv4 } from 'uuid';
import { UserContext } from '../../context/userContext';

export default function LoginTestUser() {
    const { userNum } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();
    const { setUser } = useContext(UserContext);

    useEffect(() => {
        loginTestUser();
    }, [userNum, history]);

    const loginTestUser = async () => {
        try {
            const response = await ApiService.testUserLogin({
                number: userNum
            });

            setUser(response["result"]);
            localStorage.setItem("userData", JSON.stringify(response.result));
            cookieStorage.createCookie( "userId", getUserId() );

            localStorage.setItem("token", response.result["token"]);
            localStorage.setItem("sessionId", uuidv4());
            localStorage.setItem("streamingBalance", response.result["userData"]["streamingBalance"] );

            cookieStorage.createCookie("Authorization",response.result["token"], 1 );
            cookieStorage.createCookie("SikiAccounts",JSON.stringify(response.result["accounts"]),1);
            cookieStorage.createCookie("swapObject",JSON.stringify(response.result["swapObject"]),1);

            history.push('/app');

        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return null;
}
